import React from "react";
import classNames from "classnames";
import UniversalTableContext from "../../../../../lib/UniversalTable/UniversalTableContext";
import ApiHelper from "../../../../../lib/UniversalTable/CoreHelpers/ApiHelper";
import withDeviceType from "../../../../../hocs/withDeviceType";
import SearchIcon from "../assets/search-icon.svg";
import HeadingSearchPopover from "./HeadingSearchPopover";

import "../rendererStyles/Heading.scss";
import withTranslations from "../../../../../hocs/withTranslations";

@withDeviceType
@withTranslations
class Heading extends React.Component {
  static contextType = UniversalTableContext;

  anchorRef = React.createRef();

  state = {
    searchVisible: false,
    searchValue: ""
  };

  getFilterAttribute = () =>
    ApiHelper.getColumnAttributeForFiltering(this.props.columnMetaData);

  getSortAttribute = () =>
    ApiHelper.getColumnAttributeForSorting(this.props.columnMetaData);

  showSearch = () => {
    const { search } = this.context;
    const filterAttribute = this.getFilterAttribute();

    this.setState({
      searchVisible: true,
      searchValue: search[filterAttribute] || ""
    });
  };

  hideSearch = () => {
    if (!this.state.searchVisible) {
      return;
    }

    this.setState({
      searchVisible: false
    });
  };

  applySearch = tickerOverride => {
    const searchValue =
      typeof tickerOverride === "string" ? tickerOverride : this.state.searchValue;
    const { search, setSearch } = this.context;
    const filterAttribute = this.getFilterAttribute();

    delete search[filterAttribute];

    if (searchValue.length) {
      search[filterAttribute] = searchValue;
    }

    setSearch(search);
    this.hideSearch();
  };

  handleSearchValueChange = searchValue => {
    this.setState({ searchValue });
  };

  handleSortClick = () => {
    const { isMobile } = this.props;
    const { sortBy, setSorting } = this.context;
    const sortAttribute = this.getSortAttribute();
    const sortable = ApiHelper.getIsSortable(this.props.columnMetaData);

    if (isMobile || !sortable) {
      return;
    }

    const isSortedBy = sortBy.field === sortAttribute;
    const shouldSort = !isSortedBy || sortBy.direction === "desc";

    setSorting({
      field: shouldSort ? sortAttribute : null,
      direction: !isSortedBy ? "desc" : "asc"
    });
  };

  render() {
    const { value, isMobile, columnMetaData, translate } = this.props;
    const { searchVisible, searchValue } = this.state;
    const { sortBy } = this.context;

    const sortAttribute = this.getSortAttribute();
    const filterAttribute = this.getFilterAttribute();
    const isSortedBy = sortBy.field === sortAttribute;
    const sortDirection = sortBy.direction;
    const sortable = ApiHelper.getIsSortable(columnMetaData);
    const searchable =
      ApiHelper.getIsSearchable(columnMetaData) ||
      ApiHelper.getIsDynamicAutocomplete(columnMetaData);
    const isDynamicAutocomplete =
      ApiHelper.getIsDynamicAutocomplete(columnMetaData);

    return (
      <div className="heading-renderer" ref={this.anchorRef}>
        <div
          className={classNames({
            "heading-renderer-default": true,
            sortable
          })}
          onClick={this.handleSortClick}
        >
          <span>{value}</span>
          {isSortedBy ? (
            <i
              className={classNames({
                far: true,
                "fa-long-arrow-down": sortDirection === "desc",
                "fa-long-arrow-up": sortDirection === "asc"
              })}
            />
          ) : null}
          {!isMobile && searchable ? (
            <span
              className={classNames("show-search-input", {
                active: searchVisible
              })}
              onClick={event => {
                event.stopPropagation();
                this.showSearch();
              }}
            >
              <img
                src={SearchIcon}
                width={14}
                height={14}
                alt={translate("search")}
              />
            </span>
          ) : null}
        </div>
        {searchVisible ? (
          <HeadingSearchPopover
            anchorRef={this.anchorRef}
            attributeForFiltering={filterAttribute}
            searchValue={searchValue}
            onSearchValueChange={this.handleSearchValueChange}
            onApply={this.applySearch}
            onClose={this.hideSearch}
            autocomplete={isDynamicAutocomplete}
            filterDataUrl={
              isDynamicAutocomplete
                ? columnMetaData.filter_data.url
                : undefined
            }
          />
        ) : null}
      </div>
    );
  }
}

export default Heading;
